var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM8.8001 4.80014C8.8001 4.35831 8.44193 4.00014 8.0001 4.00014C7.55827 4.00014 7.2001 4.35831 7.2001 4.80014V7.66873C7.2001 8.09307 7.36867 8.50004 7.66873 8.8001L9.43446 10.5658C9.74687 10.8782 10.2534 10.8782 10.5658 10.5658C10.8782 10.2534 10.8782 9.74687 10.5658 9.43446L8.8001 7.66873V4.80014Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGray);
export default __webpack_public_path__ + "static/media/clock-gray.005537e7078ce5ebdef1e51f5e90a537.svg";
export { ForwardRef as ReactComponent };